import { render, staticRenderFns } from "./ClipboardTextMultiple.vue?vue&type=template&id=5fb1b8fc&"
import script from "./ClipboardTextMultiple.vue?vue&type=script&lang=js&"
export * from "./ClipboardTextMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports